import PropTypes from "prop-types";
import { ProductCollectionContextProvider } from "vino/context/ProductCollectionsContext";
import ProductCollectionsGridList from "./ProductCollectionsGridList";

const ProductCollectionsListContainer = ({ children }) => {
	return (
		<ProductCollectionContextProvider>
			<ProductCollectionsGridList />
		</ProductCollectionContextProvider>
	);
};

ProductCollectionsListContainer.propTypes = {
	attributes: PropTypes.object,
	children: PropTypes.node,
};

export default ProductCollectionsListContainer;
